import React, { useEffect, useState } from "react";
import Layout from "../Layout/Content";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/auth";
import { ethers } from "ethers";
import { StackAbi, StackAddress, StakeAbi, StakeAddress, contractABI, contractAddress, deodToken, deodTokenABI, nefi3token, nefi3tokenABI, nefiStaking, nefiStakingABI, nefiToken, nefiTokenABI, salev1, salev1ABI } from "../Abi/Content";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import axios from "axios";
import { BigNumber } from "bignumber.js";
import UserPageSection from "./Content";
import Loading from "../LoaderPageSection/Loading";
import deodLogo from "../../../image/Logo.png";
import UsdtLogo from "../../../image/tether-logo.png";
import { motion } from "framer-motion";
import { Oval } from "react-loader-spinner";
const Dashboard = () => {
  const token = sessionStorage.getItem('token')

  const navigate = useNavigate();
  const [auth, setAuth] = useAuth({});
  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState("");
  const [refferal, setRefferal] = useState("");
  const [totalToken, setTotalToken] = useState("0");
  const [totalClaimToken, setTotalClaimToken] = useState("0");
  const [availableClaim, setAvailableClaim] = useState("0");
  const [refferalEarn, setRefferalEarn] = useState("0");
  const [stackingData, setStackingData] = useState([]);
  const [finalTotalAmount, setFinalTotalAmount] = useState(0);
  const [usdtPrice, setUsdtPrice] = useState(0);
  const [userWithdrawnUSDTTokens, setuserWithdrawnUSDTTokens] = useState(null)
  const [userWithdrawnTokens, setuserWithdrawnTokens] = useState(null)
  const [userAvailableTokens, setuserAvailableTokens] = useState(null)
  const [totalSAFXTokensPurchased, settotalSAFXTokensPurchased] = useState(null)
  const [getUserReferralEarning, setgetUserReferralEarning] = useState(null)
  const [getUsdtReferalEarning, setgetUsdtReferalEarning] = useState(null)
  const [getCurrentNefiPrice, setgetCurrentNefiPrice] = useState(0)
  const [userDeodReceived, setuserDeodReceived] = useState(0)
  const [deodStaked, setdeodStaked] = useState(0)
  const [usertotalsell, setusertotalsell] = useState(0)
  const [usertotalbuy, setusertotalbuy] = useState(0)
  const [unclaimedNefiTokens, setunclaimedNefiTokens] = useState(0)
  const [totalDeodStaked, settotalDeodStaked] = useState(0)
  const [claimedNefiTokens, setclaimedNefiTokens] = useState(0)
  const [referralRewards, setreferralRewards] = useState(0)
  const [buyValue, setbuyValue] = useState(0)
  const [claimValue, setclaimValue] = useState(0)
  const [sellValue, setsellValue] = useState(0)
  const [deodbuyValue, setdeodbuyValue] = useState(0)
  const [deodclaimValue, setdeodclaimValue] = useState(0)
  const [deodsellValue, setdeodsellValue] = useState(0)
  const [deodBalance, setDeodBalance] = useState(0)
  const [priority, setpriority] = useState(false)
  const [loadText, setloadText] = useState('')
  const [totalSupply, settotalSupply] = useState(0)
  const [nefiUsdPrice, setnefiUsdPrice] = useState(0)
  const [totalStaked, setTotalStaked] = useState(0)
  const [myreferrer, setmyreferrer] = useState('')
  // const [totalDeodStaked,settotalDeodStaked] = useState(0)
  const [circulatingNefiSupply, setcirculatingNefiSupply] = useState(0)
  const [userprioritystatus, setuserprioritystatus] = useState(false)
  const [prealloted, setPrealloted] = useState(false)

  const [UsertotalNefiAiClaimed, setUsertotalNefiAiClaimed] = useState('')
  const [UsertotalPurchasedNefiAiClaimed, setUsertotalPurchasedNefiAiClaimed] = useState('')
  const [UsertotaldeodStaked, setUsertotaldeodStaked] = useState('')
  const [UsertotalNefiAiBought, setUsertotalNefiAiBought] = useState('')
  const [availableToClaimPurchased, setavailableToClaimPurchased] = useState('')
  const [availableToClaim, setavailableToClaim] = useState('')
  const [totalAllotedNefiAi, setTotalAllotedNefiAi] = useState('')
  const [referralRewardsAccumulated, setreferralRewardsAccumulated] = useState('')
  const [totalNefiAiBought, settotalNefiAiBought] = useState('')
  const [rewardPoolAmount, setRewardPoolAmount] = useState('')
  const [todaysRewardforNefi, setTodaysRewardforNefi] = useState('')
  const [totalStakedToken, setTotalStakedToken] = useState('')
  const [availablePrincipal, setAvailablePrincipal] = useState('')
  const [availableReward, setAvailableReward] = useState('')
  const [totalReferralEarning, setTotalReferralEarning] = useState('')
  const [accRewardPerShare, setaccRewardPerShare] = useState('')
  const [stakes, setStakes] = useState([])
  const targetDate = new Date('2024-10-29T12:30:00').getTime();
  const [timeLeft, setTimeLeft] = useState(targetDate - new Date().getTime());

  let getLocalData = sessionStorage.getItem("auth");
  getLocalData = JSON.parse(getLocalData);


  // const networkId = 137  //mainnet
  const networkId = 56  //testnet
  //    /*Switch to mainnet*/  const networkData = [
  //         {
  //             chainId: ethers.utils.hexlify(networkId),
  //             rpcUrls: ["https://polygon-rpc.com"],

  //             chainName: "Polygon Mainnet",
  //             nativeCurrency: {
  //                 name: "MATIC",
  //                 symbol: "MATIC", // 2-6 characters long
  //                 decimals: 18,
  //             },
  //             blockExplorerUrls: ["https://polygonscan.com/"],
  //         },
  //     ]
      /*Switch to Testnet*/  const networkData = [
    {
      chainId: networkId,
      rpcUrls: ["https://bsc-dataseed.binance.org/"],

      chainName: "BNB Smart Chain",
      nativeCurrency: {
        name: "BNB",
        symbol: "BNB", // 2-6 characters long
        decimals: 18,
      },
      blockExplorerUrls: ["https:/https://bscscan.com/"],
    },
  ]
  const switchNetworks = async () => {

    try {
      await window.ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: ethers.utils.hexlify(networkId) }],
      });
    } catch (switchError) {
      // This error code indicates that the chain has not been added to MetaMask.
      if (switchError.code === 4902) {
        try {
          await window.ethereum.request({
            method: 'wallet_addEthereumChain',
            params: networkData
          });
        } catch (addError) {
          // handle "add" error
        }
      }
      // handle other "switch" errors
    }

  }
  const loadData = async () => {
    // setLoading(true);
    try {
      let provider;
      if (window?.ethereum) {
        provider = window?.ethereum;
      } else if (window?.web3) {
        provider = window?.web3?.currentProvider;
      } else {
        window.alert("No ethereum browser !checkout metamask");
      }
      if (provider) {
        if (provider !== window?.ethereum) {
          console.error(
            "Not window.ethereum.Do you have multiple wallets installed"
          );
        }
        await provider.request({
          method: "eth_requestAccounts",
        });
      }
      const oldProvider = new ethers.providers.Web3Provider(window.ethereum);
      const network = await oldProvider.getNetwork();
      console.log(network)
      if (network.chainId !== networkId) {
        await switchNetworks();
      }
      const newProvider = new ethers.providers.Web3Provider(window?.ethereum);
      const signer = newProvider.getSigner();
      const currentaccount = await signer.getAddress();
      const address = currentaccount.toLowerCase();
      setAddress(address)
      const contract = new ethers.Contract(nefiStaking, nefiStakingABI, signer)
      const referrer = await contract.referral(address)
      setmyreferrer(referrer)
      // const totalSupply = await nefiContract.totalSupply()
      // settotalSupply(parseFloat(totalSupply) / 10 ** 18)
      // const balanceofcontract = await nefiContract.balanceOf(nefiPro)
      // setBalanceofcontract(parseFloat(balanceofcontract) / 10 ** 18)
      // let totalAmountCount = await StakeContract.userDepositCounts(address);
      // totalAmountCount = parseInt(totalAmountCount);

      // for (let index = 0; index < totalAmountCount; index++) {
      //   let totalAmount = await StakeContract.userDepositIds(address, index);
      //   totalAmount = parseInt(totalAmount);

      //   let totaldepositInfo = await StakeContract.depositInfo(totalAmount);
      //   // totaldepositInfo = parseFloat(totaldepositInfo);
      //   console.log("totaldepositInfo************", totaldepositInfo);
      // }
    } catch (error) {
      console.log("loadBlockchainData", error);
    }
    // setLoading(false);
  };
  const getNefiPrice = async () => {
    try {
      const newProvider = new ethers.providers.Web3Provider(window?.ethereum);
      const signer = newProvider.getSigner();
      const currentaccount = await signer.getAddress();
      const address = currentaccount.toLowerCase();
      setAddress(address)
      const nefiContract = new ethers.Contract(nefiToken, nefiTokenABI, signer)
      const getCurrentNefiPrice = await nefiContract.getCurrentNefiPrice()
      setgetCurrentNefiPrice(parseFloat(getCurrentNefiPrice) / 10 ** 18)
      const totalDeodStaked = await nefiContract.totalDeodStaked()
      settotalDeodStaked(parseFloat(totalDeodStaked) / 10 ** 18)
      const circulatingNefiSupply = await nefiContract.circulatingNefiSupply()
      setcirculatingNefiSupply(parseFloat(circulatingNefiSupply) / 10 ** 18)
      const totalSupply = await nefiContract.totalSupply()
      settotalSupply(parseFloat(totalSupply) / 10 ** 18)

      const unitvalue2 = 1
      const deodVal = parseFloat(((+getCurrentNefiPrice)) + ((+getCurrentNefiPrice) * 0.425645)) / 10 ** 18
      // const usdtnefiPrice = deodVal
      const resp = await axios('https://backend.nexdefi.ai/deodprice');
      const nefiUsdPrice = (resp.data.usdPrice) * +deodVal
      // console.log((resp.data.priceRoute.destUSD) * +deodVal,'usd')
      setnefiUsdPrice(nefiUsdPrice)
      // ((((unitValue) * (getCurrentNefiPrice)) + (unitValue * (getCurrentNefiPrice) * 0.42565)).toFixed(3))
      // const deodVal = (unitValue / getCurrentNefiPrice) - (unitValue / getCurrentNefiPrice * 0.3)
      // console.log(deodVal,'deodVal')
    } catch (error) {
      console.log(error)
    }

  }
  const [timerLeft, setTimerLeft] = useState(0); // Initialize with 60 seconds
  const [isActive, setIsActive] = useState(false); // Track if timer is active

  useEffect(() => {
    let timer;

    if (isActive && timerLeft > 0) {
      timer = setInterval(() => {
        setTimerLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timerLeft === 0) {
      clearInterval(timer);
      setIsActive(false); // Stop timer when it reaches zero
    }

    // Cleanup the interval on component unmount or when the timer stops
    return () => clearInterval(timer);
  }, [isActive, timerLeft]);

  const startTimer = () => {
    setTimerLeft(60); // Reset to 60 seconds
    setIsActive(true); // Start the timer
  };
  const handleClaimAPI = async (trxHash) => {

    const token = sessionStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // You can adjust this as needed
    };
    const bodyData = {
      "deodAmount": deodclaimValue,
      "rate": getCurrentNefiPrice,
      "nefiAmount": claimValue,
      "transactionHash": trxHash
    };
    try {
      const resp = await axios.post(`/api/claim-token`, bodyData, {
        headers,
      });
      if (resp.status === 200) {
        if (resp?.data?.status === true) {
          toast.success(resp?.data?.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          // window.location.reload(false);
          loadData()
          // startTimer()
        } else {
          toast.error("Error", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      } else {
        toast.error("Error", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      if (error.response.status === 400) {
        var err_400 = error?.response?.data?.message;
        toast.error(err_400);
      } else if (error.response.status === 401) {
        const err_401 = error?.response?.data?.message;
        toast.error(err_401);
      } else if (error.response.status === 404) {
        const err_404 = error?.response?.data?.message;
        toast.error(err_404);
      } else if (error.response.status === 500) {
        const err_500 = error?.response?.data?.message;
        toast.error(err_500);
      } else {
        console.log("Error in Register", error);
        toast.error("something went wrong");
      }
    }
  };
  const handleBuyApi = async () => {
    const token = sessionStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // You can adjust this as needed
    };
    const bodyData = {
      "accountAddress": address,
      "refferalAddress": myreferrer,
      "amountInDeod": deodbuyValue,
      "amountoutNefi": buyValue,
      "currentDeodRate": +getCurrentNefiPrice + 12
    };
    try {
      const data = {
        "accountAddress": "0x7f967ec284cE3E3E3503C19dB74dc697aEa4c0F2"
      }
      // const login = await axios.post(`https://nefi.onrender.com/api/v1/user/login`, data,{ withCredentials: true });
      // if (login.status==200) {

      const resp = await axios.post(`https://nefi.onrender.com/api/v1/buy/buyNefi`, bodyData, { withCredentials: true });
      if (resp.status === 200) {
        if (resp?.data?.status === true) {
          toast.success(resp?.data?.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        // window.location.reload(false);
        // loadData()
        // startTimer()
      } else {
        toast.error("Error", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      // } else {
      //   toast.error("Error", {
      //     position: toast.POSITION.TOP_RIGHT,
      //   });
      // }
    } catch (error) {
      if (error.response.status === 400) {
        var err_400 = error?.response?.data?.message;
        toast.error(err_400);
      } else if (error.response.status === 401) {
        const err_401 = error?.response?.data?.message;
        toast.error(err_401);
      } else if (error.response.status === 404) {
        const err_404 = error?.response?.data?.message;
        toast.error(err_404);
      } else if (error.response.status === 500) {
        const err_500 = error?.response?.data?.message;
        toast.error(err_500);
      } else {
        console.log("Error in Register", error);
        toast.error("something went wrong");
      }
    }
  }
  const handleSellApi = async (trxHash) => {

  }
  const handleClaim = async () => {
    setLoading(true);
    try {
      let provider;
      if (window.ethereum) {
        provider = window.ethereum;
      } else if (window.web3) {
        provider = window.web3.currentProvider;
      } else {
        window.alert("No ethereum browser !checkout metamask");
      }
      if (provider) {
        if (provider !== window.ethereum) {
          console.error(
            "Not window.ethereum.Do you have multiple wallets installed"
          );
        }
        await provider.request({
          method: "eth_requestAccounts",
        });
      }
      const newProvider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = newProvider.getSigner();
      const currentaccount = await signer.getAddress();
      const address = currentaccount.toLowerCase();
      const storeAddress = auth?.user?.address;
      if (address === storeAddress) {
        const StakeContract = new ethers.Contract(
          StakeAddress,
          StakeAbi,
          signer
        );
        const txn = await StakeContract.withdrawTokens(address);
        const receipttxn1 = await txn.wait();
        if (receipttxn1.status !== 1) {
          toast.error("Error");
        } else {
          const hash = await receipttxn1.transactionHash;
          await handleClaimAPI(hash);
        }
      } else {
        toast.error("Connect correct wallet");
      }
    } catch (error) {
      console.log("loadBlockchainData", error);
      toast.error(`${JSON.stringify(error.reason)}`, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
    setLoading(false);
    window.location.reload(false);
  };

  const handleUnitChangeBuy = (e) => {
    const unitValue = e.target.value;
    setdeodbuyValue(e.target.value)
    setbuyValue(((unitValue / getCurrentNefiPrice) - (unitValue / getCurrentNefiPrice * 0.12)).toFixed(2));
  };
  const handleUnitChangeSell = (e) => {
    let unitValue;
    if (typeof e === "object") {
      console.log('object')
      unitValue = e.target.value;
    }
    else {
      unitValue = e - 0.001
    }
    if (unitValue < 0) {
      unitValue = 0
    }
    setsellValue(unitValue.toString())
    setdeodsellValue(((unitValue * getCurrentNefiPrice) - (unitValue * getCurrentNefiPrice * 0.15)).toFixed(3));
  };
  const handleUnitChangeClaim = (e) => {
    const unitValue = e.target.value;
    setclaimValue(e.target.value)
    setdeodclaimValue((unitValue * getCurrentNefiPrice).toFixed(3));
  };
  const handlesubUnitChangeBuy = (e) => {
    const unitValue = e.target.value;
    setdeodbuyValue((((unitValue) * (getCurrentNefiPrice)) + (unitValue * (getCurrentNefiPrice) * 0.42565)).toFixed(3));
    setbuyValue(e.target.value)
  };
  const handlesubUnitChangeSell = (e) => {
    const unitValue = e.target.value;
    setsellValue(((unitValue / (getCurrentNefiPrice)) + (unitValue / (getCurrentNefiPrice * 0.85)) * 0.15).toFixed(3));
    setdeodsellValue(e.target.value)
  };
  const handlesubUnitChangeClaim = (e) => {
    const unitValue = e.target.value;
    // setclaimValue(e.target.value)
    // setdeodclaimValue((unitValue / getCurrentNefiPrice).toFixed(6));
    setdeodclaimValue(e.target.value)
    setclaimValue((unitValue / getCurrentNefiPrice).toFixed(3));
  };

  const calculateBuyPercentage = (perc) => {
    const numb = (deodBalance * perc) / 100;
    if (deodBalance >= 10000) {
      setdeodbuyValue("10000")
      setbuyValue(((10000 / getCurrentNefiPrice) - (10000 / getCurrentNefiPrice * 0.3)).toFixed(3).toString())

    } else {
      alert('Insufficient Balance')
    }
  };
  const calculateClaimPercentage = (perc) => {
    const numb = (unclaimedNefiTokens * perc) / 100;
    setclaimValue((numb - 0.001).toFixed(3).toString())
  };
  const calculateSellPercentage = (perc) => {
    const numb = (unclaimedNefiTokens * perc) / 100;
    handleUnitChangeSell(numb)
    // setsellValue(numb.toFixed(4).toString())
  };

  const checkStatus = () => {
    return new Promise((resolve) => {
      const intervalId = setInterval(() => {
        setLoading(true);
        setloadText('Transaction Queued')

        if (userprioritystatus) {
          clearInterval(intervalId); // Stop checking when status is true
          resolve(true);             // Resolve the promise to proceed
        }
      }, 2000); // Check every second
    });
  };

  const handleBuyNefi = async () => {
    // alert("Coming Soon")
    try {
      if (+deodbuyValue >= 5 && +deodbuyValue <= 100000000) {
        // if (+deodBalance < +deodbuyValue) {
        //   return alert('Insufficient Deod Balance')
        // }
        setLoading(true);
        setloadText('Transaction Processing')
        const newProvider = new ethers.providers.Web3Provider(window?.ethereum);
        const signer = newProvider.getSigner();
        const currentaccount = await signer.getAddress();
        const address = currentaccount.toLowerCase();
        const nefiContract = new ethers.Contract(nefi3token, nefi3tokenABI, signer)
        const stakingContract = new ethers.Contract(nefiStaking, nefiStakingABI, signer)


        //approve nefi
        const approveTx = await nefiContract.approve(nefiStaking, ethers.utils.parseEther(deodbuyValue))
        const aprRcpt = await approveTx.wait()
        //stake nefi
        if (aprRcpt.status === 1) {
          console.log(ethers.utils.parseEther(deodbuyValue))
          const buyTx = await stakingContract.stake(ethers.utils.parseEther(deodbuyValue))
          const buyRcpt = await buyTx.wait()

          if (buyRcpt.status === 1) {
            // await handleBuyApi()
            alert('Transaction Successful')
          }
          // await loadData()
          await getNefi3data()
          setdeodbuyValue(0)
        }
      } else {
        alert('Please enter correct Amount . Amount should be more than 5 ')
      }
    } catch (error) {
      console.log(error)
      alert("Error while Buy Nefi ")
    }
    setloadText('')
    setLoading(false);
  }
  const handleClaimNefi = async () => {
    // alert("Something Went Wrong , Please Try Again")
    setLoading(true);
    try {

      // Claim NEFI
      const newProvider = new ethers.providers.Web3Provider(window?.ethereum);
      const signer = newProvider.getSigner();
      const currentaccount = await signer.getAddress();
      const address = currentaccount.toLowerCase();
      const nefiContract = new ethers.Contract(nefiToken, nefiTokenABI, signer)
      const deodContract = new ethers.Contract(deodToken, deodTokenABI, signer)

      const claimTx = await nefiContract.claimTokens(ethers.utils.parseEther(claimValue))
      const claimRcpt = await claimTx.wait()

      if (claimRcpt.status === 1) {
        alert('Claim Success')
        handleClaimAPI(claimRcpt.transactionHash)
        // await loadData()
      }
    } catch (error) {
      console.log(error)
    }
    setLoading(false);

  }
  const handleSellNefi = async () => {
    // alert("Coming Soon")
    try {
      setLoading(true);

      //Sell NEFI
      const newProvider = new ethers.providers.Web3Provider(window?.ethereum);
      const signer = newProvider.getSigner();
      const currentaccount = await signer.getAddress();
      const address = currentaccount.toLowerCase();
      const nefiContract = new ethers.Contract(nefiToken, nefiTokenABI, signer)
      const deodContract = new ethers.Contract(deodToken, deodTokenABI, signer)

      const sellTx = await nefiContract.sellNefi(ethers.utils.parseEther(sellValue))
      const sellRcpt = await sellTx.wait()

      if (sellRcpt.status === 1) {
        alert('Sell Success')
        await loadData()
      }
    } catch (error) {
      toast.error("Max Sell Limit Exceeded")
    }
    setLoading(false);

  }
  const start_and_end = (address) => {
    if (address !== undefined) {
      return (
        address.substr(0, 10) +
        "...." +
        address.substr(address.length - 10, address.length)
      );
    }
    return address;
  };
  const handleCopy = () => {
    let text = `https://staking.nexdefi.ai/?referral=${address}`;
    text.trim();
    navigator.clipboard.writeText(text);
    alert('Referral Link Copied')
  };

  const checkPriority = async () => {
    try {
      const token = sessionStorage.getItem('token')
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json", // You can adjust this as needed
      };
      const api = `/check/check-priority`
      const payload = {
        "deodAmount": 50,
        "rate": 0.5,
        "nefiAmount": 20
      }
      const resp = await axios.post(api, payload, {
        headers,
      })
      // console.log(resp.data.isPriority)
      setpriority(resp.data.isPriority)
      return resp.data.isPriority
    } catch (error) {
      console.log(error)
    }
  }
  const priorityBuyApi = async (trxHash) => {
    const token = sessionStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // You can adjust this as needed
    };
    const api = '/api/complete-purchase'
    const payload = {
      "deodAmount": deodbuyValue,
      "rate": getCurrentNefiPrice,
      "nefiAmount": buyValue,
      "transactionHash": trxHash
    }
    try {
      const resp = await axios.post(api, payload, {
        headers,
      });
      if (resp.status === 200) {
        if (resp?.data?.status === true) {
          toast.success(resp?.data?.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          // window.location.reload(false);
          loadData()
          if (!priority) {
            startTimer()
          }
        } else {
          toast.error("Error", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      } else {
        toast.error("Error", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      if (error.response.status === 400) {
        var err_400 = error?.response?.data?.message;
        toast.error(err_400);
      } else if (error.response.status === 401) {
        const err_401 = error?.response?.data?.message;
        toast.error(err_401);
      } else if (error.response.status === 404) {
        const err_404 = error?.response?.data?.message;
        toast.error(err_404);
      } else if (error.response.status === 500) {
        const err_500 = error?.response?.data?.message;
        toast.error(err_500);
      } else {
        console.log("Error in Register", error);
        toast.error("something went wrong");
      }
    }
  }
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const now = new Date();

    // Create a date for today at 6 PM IST
    const today = new Date();
    const istOffset = 5.5 * 60; // IST is UTC+5:30
    const utc = today.getTime() + (today.getTimezoneOffset() * 60000);
    const sixPMIST = new Date(utc + istOffset * 60000);
    sixPMIST.setHours(18, 0, 0, 0); // Set time to 6:00 PM IST

    // Recalculate the date with time set to 6 PM IST
    const targetTime = new Date(sixPMIST);

    if (now >= targetTime) {
      setEnabled(true); // Already past 6 PM IST
    } else {
      const delay = targetTime - now;
      const timer = setTimeout(() => setEnabled(true), delay);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleCopyy = (str) => {
    let text = `${str}`;
    text.trim();
    navigator.clipboard.writeText(text);
    alert('Text Copied')
  };
  const submitTokens = async (contractNumber) => {
    let targetUrl = contractNumber === 1
      ? "https://token.nexdefi.ai/contract1"
      : "https://token.nexdefi.ai/contract2";

    window.location.href = targetUrl;
  }
  const checkregularUserStatus = async () => {
    if (!priority) {
      await new Promise(resolve =>
        setTimeout(resolve, 300000)
      ); // Waits for 1 minute
      return true;
    }
  }
  const getNefi3data = async () => {

    setLoading(true)
    try {
      // debugger
      const newProvider = new ethers.providers.Web3Provider(window?.ethereum);
      const signer = newProvider.getSigner();
      const currentaccount = await signer.getAddress();
      const address = currentaccount.toLowerCase();
      setAddress(address)
      const contract = new ethers.Contract(nefi3token, nefi3tokenABI, signer)
      const stakingContract = new ethers.Contract(nefiStaking, nefiStakingABI, signer)
      const availablePrincipal = await stakingContract.availablePrincipal(currentaccount)
      const availableReward = await stakingContract.availableReward(currentaccount)
      const dailyPool = await stakingContract.dailyPool()
      const totalReferralEarned = await stakingContract.totalReferralEarned(currentaccount)
      const totalStaked = await stakingContract.totalStaked()
      const accRewardPerShare = await stakingContract.accRewardPerShare()
      setaccRewardPerShare(ethers.utils.formatEther(accRewardPerShare))
      const balanceOfnefiStaking = await contract.balanceOf(nefiStaking)
      const balanceOfUser = await contract.balanceOf(currentaccount)
      setDeodBalance(ethers.utils.formatEther(balanceOfUser))
      setRewardPoolAmount(+ethers.utils.formatEther(balanceOfnefiStaking) - +ethers.utils.formatEther(totalStaked))
      setTodaysRewardforNefi(dailyPool)
      setTotalStaked(ethers.utils.formatEther(totalStaked))
      setAvailablePrincipal(availablePrincipal)
      setAvailableReward(availableReward)
      setTotalReferralEarning(totalReferralEarned)
      console.log(availablePrincipal, 'availablePrincipal', availableReward, 'availableReward', dailyPool, 'dailyPool', totalReferralEarned, 'totalReferralEarned', +ethers.utils.formatEther(balanceOfnefiStaking) - +ethers.utils.formatEther(totalStaked), 'totalStaked')
      //  console.log(ethers.utils.formatEther(totalNefiAiBought),'hello')
      const results = [];
      let index = 0;
      while (true) {
        try {
          // const result = await contract.someGetter(index); // Replace with your function
          const result = await stakingContract.stakes(currentaccount, index)
          // console.log(`Index ${index}:`, result);
          results.push(result);
          index++;
        } catch (err) {
          console.warn(`No more data at index ${index}. Stopping loop.`);
          break;
        }
      }
      console.log(ethers.utils.formatUnits(results[0][1], 1), 'results')
      setStakes(results)
      if (!results.length == 0) {
        setPrealloted(true)
        const total = results.reduce((acc, row) => {
          const bnAsNumber = +ethers.utils.formatEther(row[0]);
          return acc + bnAsNumber;
        }, 0);
        setTotalStakedToken(total)

        console.log(total);
        setTotalAllotedNefiAi(total)
      }
    } catch (error) {
      console.warn(error)
    }
    setLoading(false)
  }
  // const handleclaimPurchasedTokens = async () => {
  //   if (+ethers.utils.formatEther(availableReward) == 0) {
  //       return alert('No tokens available to Claim')
  //     }
  //   setLoading(true)

  //   try {
      
  //     const newProvider = new ethers.providers.Web3Provider(window?.ethereum);
  //     const signer = newProvider.getSigner();
  //     const currentaccount = await signer.getAddress();
  //     const address = currentaccount.toLowerCase();
  //     // setAddress(address)
  //     const contract = new ethers.Contract(nefiStaking, nefiStakingABI, signer)
  //     const trx = await contract.claimReward()
  //     const rcpt = await trx.wait()
  //     if (rcpt.status == 1) {
  //       alert('Claim Successful')
  //     }
  //     getNefi3data()
  //   } catch (error) {
  //     console.log(error)
  //     alert('Error while claiming tokens')
  //   }
  //   setLoading(false)
  // }
  const handleclaimPurchasedTokens = async () => {

  }
  // const handleclaimPrincipal = async () => {
  //    if (+ethers.utils.formatEther(availablePrincipal) == 0) {
  //       return alert('No Tokens Available for Unstaking')
  //     }
  //   setLoading(true)

  //   try {
     
  //     const newProvider = new ethers.providers.Web3Provider(window?.ethereum);
  //     const signer = newProvider.getSigner();
  //     const currentaccount = await signer.getAddress();
  //     const address = currentaccount.toLowerCase();
  //     // setAddress(address)
  //     const contract = new ethers.Contract(nefiStaking, nefiStakingABI, signer)
  //     const trx = await contract.claimPrincipal()
  //     const rcpt = await trx.wait()
  //     if (rcpt.status == 1) {
  //       alert('Claim Successful')
  //     }
  //     getNefi3data()
  //   } catch (error) {
  //     console.log(error)
  //     alert('Error while Unstaking tokens')
  //   }
  //   setLoading(false)
  // }
   const handleclaimPrincipal = async () => {
  }
  const handleclaimTokens = async () => {
    setLoading(true)
    try {
      const newProvider = new ethers.providers.Web3Provider(window?.ethereum);
      const signer = newProvider.getSigner();
      const currentaccount = await signer.getAddress();
      const address = currentaccount.toLowerCase();
      // setAddress(address)
      const contract = new ethers.Contract(nefi3token, nefi3tokenABI, signer)
      const trx = await contract.claimTokens()
      const rcpt = await trx.wait()
      if (rcpt.status == 1) {
        alert('Claim Successful')
      }
    } catch (error) {
      console.log(error)
    }
    setLoading(false)
  }
  // const nefiUsdPrice = async () => {
  //   const unitvalue2 = 1
  //   const deodVal = (unitvalue2 / getCurrentNefiPrice) - (unitvalue2 / getCurrentNefiPrice * 0.3)
  //   console.log(deodVal,'deodVal')
  // }
  // State to hold remaining time in seconds
  const formatTimeLeft = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const days = Math.floor(hours / 24)
    const remainingHours = hours % 24
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return {
      days,
      remainingHours,
      minutes,
      seconds,
    };
  };
  // useEffect to update the countdown
  const { days, remainingHours, minutes, seconds } = formatTimeLeft(timeLeft);
  useEffect(() => {
    const intervalId = setInterval(() => {
      const currentTime = new Date().getTime();
      const difference = targetDate - currentTime;

      // Stop the countdown when time runs out
      if (difference <= 0) {
        clearInterval(intervalId);
        setTimeLeft(0);
      } else {
        setTimeLeft(difference);
      }
    }, 1000);

    // Cleanup interval when component unmounts
    return () => clearInterval(intervalId);
  }, [targetDate]);
  // console.log(priority,'priority')
  useEffect(() => {
    async function handleData() {
      await loadData();
    }
    // startTimer()
    handleData();
    getNefi3data()
    // checkregularUserStatus()
  }, []);
  // useEffect(() => {
  //   if (getLocalData === null) {
  //     navigate("/");
  //   }
  // }, [getLocalData]);

  // useEffect(() => {
  //   async function handleGetParaswapPrice() {
  //     if (totalToken == 0) {
  //       setUsdtPrice(0);
  //     } else {
  //       try {
  //         let x;
  //         x = totalToken * 10 ** 18;
  //         let z = new BigNumber(x);
  //         let a = z.toFixed();
  //         // const deodToken = (totalToken * 10 ** 18).toString();
  //         const Paraswap = `https://api.paraswap.io/prices/?srcToken=0xe77abb1e75d2913b2076dd16049992ffeaca5235&destToken=0xc2132D05D31c914a87C6611C10748AEb04B58e8F&amount=${a}&srcDecimals=18&destDecimals=6&side=SELL&excludeDirectContractMethods=false&network=137&otherExchangePrices=true&partner=paraswap.io&userAddress=0x0000000000000000000000000000000000000000`;
  //         console.log("Paraswap", a);
  //         const getParaswapData = await axios.get(Paraswap);
  //         if (getParaswapData.status === 200) {
  //           let finalUSDTPrice = getParaswapData?.data?.priceRoute?.destAmount;
  //           finalUSDTPrice = (finalUSDTPrice / 10 ** 6).toFixed(2);
  //           console.log("finaldeod&&&&", finalUSDTPrice);
  //           setUsdtPrice(finalUSDTPrice);
  //         }
  //       } catch (error) {
  //         console.log("error in deod price paraswap api", error);
  //       }
  //     }
  //   }
  //   handleGetParaswapPrice();
  // }, [totalToken]);
  //   <div className="col-12 col-md-4">
  //   <div className="row my-4">
  //     <div className="col-12">
  //       <div className="card cus-card-token-ad text-center" style={{ height: '100%' }}>
  //         <div className="card-body">
  //           <div className="text-start" style={{}}>
  //             <h5>
  //               CLAIM NEFI
  //             </h5>
  //           </div>
  //           <div className="d-flex justify-content-between my-3" style={{}}>
  //             <div>
  //               <h6>
  //                 Available Balance
  //               </h6>
  //             </div>
  //             <div>
  //               <h6 className=""><i class="bi bi-wallet mx-1"></i>:{(unclaimedNefiTokens).toFixed(3)} NEFI</h6>
  //             </div>
  //           </div>
  //           <div className="d-flex justify-content-between" style={{ fontSize: `13px` }}>
  //             <div>
  //               Price:
  //             </div>
  //             <div>
  //               1 NEFI = {getCurrentNefiPrice?.toFixed(3)} DEOD
  //             </div>
  //           </div>
  //           {/* <div className="d-flex align-items-center justify-content-center my-3 p-2" style={{ background: '#232323', borderRadius: '10px' }}>
  //         <div className="">
  //           <button className="px-2" style={{ background: '#232323', border: 'none', color: 'white', textAlign: 'center' }}>!</button>
  //         </div>
  //         <div className="w-75" >
  //           <input className='w-100' style={{ background: '#232323', border: 'none', color: 'white', textAlign: 'center' }} onWheel={(e) => e.target.blur()} type="text" value={`Limit`} disabled />
  //         </div>
  //         <div>
  //           <button className="px-2" style={{ background: '#232323', border: 'none', color: 'white', textAlign: 'center' }}>▼</button>
  //         </div>
  //       </div> */}
  //           <div className="d-flex align-items-center justify-content-center my-3 p-2" style={{ background: '#232323', borderRadius: '10px' }}>
  //             <div className="">
  //               <button className="px-2" style={{ background: '#232323', border: 'none', color: 'white', textAlign: 'center' }}>NEFI:</button>
  //             </div>
  //             <div className="w-75" >
  //               <input className='w-100' style={{ background: '#232323', border: 'none', color: 'white', textAlign: 'center' }} onWheel={(e) => e.target.blur()} type="number" placeholder="Enter NEFI Amt" value={claimValue} onChange={handleUnitChangeClaim} />
  //             </div>
  //             {/* <div>
  //           <button className="px-2" style={{ background: '#232323', border: 'none', color: 'white', textAlign: 'center' }}>+</button>
  //         </div> */}
  //           </div>
  //           {/* <div className="d-flex align-items-center justify-content-center my-3 p-2" style={{ background: '#232323', borderRadius: '10px' }}>
  //       <div className="">
  //     <button className="px-2" style={{background:'#232323',border:'none',color: 'white',textAlign:'center'}}>DEOD:</button>
  //     </div>
  //         <div className="w-75">
  //           <input className='w-100 input-sale' type="text" value={deodclaimValue} onChange={handlesubUnitChangeClaim} style={{ background: '#232323', border: 'none', color: 'white', textAlign: 'center' }} />
  //         </div>
  //         <div>
  //     <button className="px-2" style={{background:'#232323',border:'none',color: 'white',textAlign:'center'}}>+</button>
  //     </div>
  //       </div> */}
  //           <div className="d-flex align-items-center justify-content-end">
  //             <p className="mx-1 hover-text" style={{ cursor: "pointer", fontSize: '15px' }} onClick={() => calculateClaimPercentage(25)}>25%</p>
  //             <p className="mx-1 hover-text" style={{ cursor: "pointer", fontSize: '15px' }} onClick={() => calculateClaimPercentage(50)}>50%</p>
  //             <p className="mx-1 hover-text" style={{ cursor: "pointer", fontSize: '15px' }} onClick={() => calculateClaimPercentage(100)}>Max</p>

  //           </div>
  //           <div>
  //             <button className="btn connect-btn w-100 rounded" style={{ fontWeight: '700' }} onClick={handleClaimNefi}>CLAIM NOW</button>
  //           </div>
  //           <div className="mt-1">
  //             <p className="text-warning text-end" style={{ fontSize: "12px" }}>* Prices are approximate , may vary somewhat.</p>
  //           </div>
  //         </div>

  //       </div>
  //     </div>
  //   </div>
  // </div>
  return (
    <UserPageSection content="content">
      {loading && <Loading loading={loading} text={loadText} />}
      <div
        style={{
          backgroundColor: "#00000054",
          overflow: "hidden",
          whiteSpace: "nowrap",
          // position: "fixed",
          bottom: 0,
          width: "100%",
          zIndex: 1000,
        }}
      >
        <motion.div
          className="d-inline-block py-2"
          style={{ whiteSpace: "nowrap" }}
          animate={{ x: ["0%", "-100%"] }}
          transition={{
            repeat: Infinity,
            ease: "linear",
            duration: 40,
          }}
        >
          <div className="d-inline-block text-white px-4">
            <span className="me-5">Accumulated Reward per Staked Nefi : {(+accRewardPerShare).toFixed(2)} </span>
          </div>

          <div className="d-inline-block text-white px-4">
            <span className="me-5">Accumulated Reward per Staked Nefi : {(+accRewardPerShare).toFixed(2)} </span>
          </div>
        </motion.div>
      </div>
      <div className="col-12">
        <div className="mt-2 px-4 py-2" style={{ background: '#0000', borderRadius: '10px', color: 'white', minHeight: '60px', fontWeight: 'bold', border: '1px solid #939797' }}>
          {!stakes.length == 0 ? <div className=" d-flex align-items-center">
            Referral Link : {`https://staking.nexdefi.ai/?${start_and_end(address)}`} <i class="bi bi-copy hover-text mx-2" onClick={handleCopy}></i>
          </div> : <div className=" d-flex align-items-center">
            Stake tokens to unlock your Referral Link
          </div>}
          <div className=" d-flex align-items-center " style={{ color: '#00ffc6', fontWeight: 'normal' }}>
            <strong>
              My Referrer : {start_and_end(myreferrer)} <i class="bi bi-copy hover-text mx-2" onClick={() => { handleCopyy(myreferrer) }}></i>
            </strong>
          </div>
          {/* <div className=" d-flex align-items-center " style={{ fontWeight: 'normal' }}>
            <strong>
              Total Nefi<span style={{ color: '#00ffc6', }}>AI</span> Staked : <span >{totalNefiAiBought && (+ethers.utils.formatEther(totalNefiAiBought)).toFixed(2)}</span>
            </strong>
          </div> */}
        </div>

      </div>
      <div className="row">
        <div className="col-12 col-md-4">
          <div className="row my-4">
            <div className="col-12">
              <div className="text-start" style={{}}>
                <h5 className="text-white pb-2">
                  STAKE NEFI<span style={{ color: '#00ffc6' }}>AI</span>
                </h5>
              </div>
              <div className=" p-3 text-white" style={{ borderRadius: "10px 0", border: "1px solid rgb(109, 109, 109)", boxShadow: '5px 5px 25px rgb(52, 53, 53)' }}>
                <div style={{ borderRadius: "10px" }}>

                  <div className="text-center" style={{ height: '100%', position: 'relative' }}>
                    {
                      timerLeft !== 0 &&
                      <div className="overlay">{timerLeft}s</div>
                    }

                    <div className="card-body">
                      <div className="d-flex my-3 justify-content-between align-items-center" style={{}}>
                        <div>
                          <h6>
                            Balance:
                          </h6>
                        </div>
                        <div>
                          <h6 className=""><i class="bi bi-wallet" style={{ color: "#12eebff7" }}></i> {" "}{(+deodBalance).toFixed()}{" "} NEFI</h6>
                        </div>
                      </div>
                      {/* <div className="d-flex align-items-center justify-content-center my-3 p-2" style={{ background: '#232323', borderRadius: '10px' }}>
                      <div className="">
                        <button className="px-2" style={{ background: '#232323', border: 'none', color: 'white', textAlign: 'center' }}>!</button>
                      </div>
                      <div className="w-75" >
                        <input className='w-100' style={{ background: '#232323', border: 'none', color: 'white', textAlign: 'center' }} onWheel={(e) => e.target.blur()} type="text" value={`Limit`} disabled />
                      </div>
                      <div>
                        <button className="px-2" style={{ background: '#232323', border: 'none', color: 'white', textAlign: 'center' }}>▼</button>
                      </div>
                    </div> */}
                      <div className="d-flex align-items-center justify-content-center my-3 p-2" style={{ background: '#232323', borderRadius: '10px' }}>
                        <div className="">
                          <button className="px-2" style={{ background: '#232323', border: 'none', color: 'white', textAlign: 'center' }}>AMOUNT:</button>
                        </div>
                        <div className="w-75" >
                          <input className='w-100' style={{ background: '#232323', border: 'none', color: 'white', textAlign: 'center' }} onWheel={(e) => e.target.blur()} type="number" max={50000} min={5} placeholder="Enter NEFI Amt" value={deodbuyValue} onChange={handleUnitChangeBuy} />
                        </div>
                        {/* <div>
                        <button className="px-2" style={{ background: '#232323', border: 'none', color: 'white', textAlign: 'center' }}>+</button>
                      </div> */}
                      </div>
                      <div className="d-flex align-items-center justify-content-center my-3 p-2" style={{ background: '#232323', borderRadius: '10px' }}>
                        <div className="">
                          <button className="px-2" style={{ background: '#232323', border: 'none', color: 'white', textAlign: 'center' }}>DAYS:</button>
                        </div>
                        <div className="w-75">
                          <input className='w-100 input-sale' type="text" value={365} disabled style={{ background: '#232323', border: 'none', color: 'white', textAlign: 'center' }} />
                        </div>

                        {/* <div>
                  <button className="px-2" style={{background:'#232323',border:'none',color: 'white',textAlign:'center'}}>+</button>
                  </div> */}
                      </div>
                      <div className="d-flex align-items-center justify-content-end">
                        {/* <p className="mx-1 hover-text" style={{cursor:"pointer",fontSize:'15px'}} onClick={()=>calculateBuyPercentage(25)}>25%</p> */}
                        {/* <p className="mx-1 hover-text" style={{cursor:"pointer",fontSize:'15px'}} onClick={()=>calculateBuyPercentage(50)}>50%</p> */}
                        {/* <p className="mx-1 hover-text" style={{ cursor: "pointer", fontSize: '15px' }} onClick={() => calculateBuyPercentage(100)}>Max</p> */}

                      </div>
                      <div>
                        <button className="btn connect-btn w-100 rounded my-2" style={{ fontWeight: '700', background: '#00ffc896' }} onClick={handleBuyNefi}>STAKE </button>
                      </div>
                      {/* <div className="mt-1">
                        <p className="text-warning text-end" style={{ fontSize: "12px" }}>* Prices are approximate , may vary somewhat.</p>
                      </div> */}
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-8">
          <div className="row my-4">
            <div className="col-12">
              <div className="card cus-card-token-ad2 text-center" style={{ height: '100%', position: 'relative' }}>
                {
                  timerLeft !== 0 &&
                  <div className="overlay">{timerLeft}s</div>
                }
                <div className="">
                  <div className="text-start mt-3" style={{}}>
                    <h5>
                      STAKED NEFI<span style={{ color: '#00ffc6' }}>AI</span>
                    </h5>
                  </div>
                  <div className="p-3 mt-3 rounded-xl" style={{ borderRadius: "10px", border: "1px solid #939797" }}>


                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-stretch gap-3">
                      <div className="w-100 pt-2 d-flex flex-column justify-content-between rounded-xl cards-content-dash" style={{ borderRadius: "10px" }}>
                        <div>
                          <h4>{totalStakedToken ? (+(totalStakedToken)).toFixed(2) : 0}</h4>
                          <p>My Staked Token </p>
                        </div>
                      </div>
                      <div className="w-100 pt-2 d-flex flex-column justify-content-between rounded-xl cards-content-dash" style={{ borderRadius: "10px" }}>
                        <div>
                          <h4>{totalStaked ? (+(totalStaked)).toFixed(2) : 0}</h4>
                          {/* <h4>{totalStakedToken && (+ethers.utils.formatEther(totalReferralEarning)).toFixed(2)}</h4> */}
                          <p>Total Staked Token </p>
                        </div>
                      </div>
                      {/* <div className="w-100 pt-2 d-flex flex-column justify-content-between rounded-xl cards-content-dash" style={{ borderRadius: "10px" }}>
                            <div>
                              <div className="d-flex justify-content-between align-items-start pt-2" style={{ padding: "0 30px" }}>
                              <p>Available for Unstaking</p>
                                <h4 className="mb-0">
                                  {availablePrincipal && (+ethers.utils.formatEther(availablePrincipal)).toFixed(2) }
                                </h4>
                              </div>
                                <button
                                  className="ms-2 mb-3 btn connect-btn rounded align-self-center"
                                  style={{ fontWeight: '700', background: '#00ffc896', color: "white", borderRadius: "7px", border: "none" }}
                                  onClick={handleclaimPrincipal}
                                >
                                  Unstake
                                </button>

                            </div>
                          </div> */}


                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div className="text-start mt-3" style={{}}>
                        <h5>
                          REWARD POOL
                        </h5>
                      </div>
                      {/* <div className="data-cards p-0 card mt-3">
                        <div className="p-3 text-center card-body table-responsive">
                          <table className="mb-0 table table-striped table-hover" >
                            <thead>
                              <tr className="border-0" >
                                <th className="font-roboto text-AmethystSmoke fs-13 fw-400 mt-3 border-0" style={{ background: 'transparent', color: 'white' }}>Purchased Tokens<span style={{ color: '#00ffc6' }}></span></th>
                                <th className="font-roboto text-AmethystSmoke fs-13 fw-400 mt-3 border-0" style={{ background: 'transparent', color: 'white' }}>DEOD Amount Spent</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr className="border-0">
                                <td className="text-capitalize font-roboto fw-400 fs-17  border-0" style={{ background: 'transparent', color: 'white' }}>{UsertotalNefiAiBought && (+ethers.utils.formatEther(UsertotalNefiAiBought)).toFixed(2)}</td>
                                <td className="text-capitalize font-roboto fw-400 fs-17  border-0" style={{ background: 'transparent', color: 'white' }}>{UsertotaldeodStaked && +ethers.utils.formatEther(UsertotaldeodStaked)}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div> */}
                      <div className="p-3 mt-3 rounded-xl" style={{ borderRadius: "10px", border: "1px solid #939797" }}>


                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-stretch gap-3">
                          <div className="w-100 pt-2 d-flex flex-column justify-content-between rounded-xl cards-content-dash" style={{ borderRadius: "10px" }}>
                            <div>
                              <h4>{rewardPoolAmount && (+(rewardPoolAmount)).toFixed(2)}</h4>
                              <p>Total Pool Amount </p>
                            </div>
                          </div>
                          <div className="w-100 pt-2 d-flex flex-column justify-content-between rounded-xl cards-content-dash" style={{ borderRadius: "10px" }}>
                            <div>
                              {/* <div className="d-flex justify-content-between align-items-center mb-3 pt-2" style={{ padding: "0 30px" }}>
                              </div> */}
                              <h4 className=" align-self-center">
                                {todaysRewardforNefi && (+ethers.utils.formatEther(todaysRewardforNefi)).toFixed(2)}
                              </h4>
                              <p>Todays Total Reward </p>

                            </div>
                          </div>


                        </div>
                      </div>

                      <div className="text-start mt-3" style={{}}>
                        <h5>
                          REWARD DETAILS
                        </h5>
                      </div>
                      <div className="p-3 mt-3 rounded-xl" style={{ borderRadius: "10px", border: "1px solid #939797" }}>
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-stretch gap-3">
                          <div className="w-100 pt-2 d-flex flex-column justify-content-between rounded-xl cards-content-dash" style={{ borderRadius: "10px" }}>
                            <div>
                              <div className="d-flex justify-content-between align-items-start pt-2" style={{ padding: "0 30px" }}>
                                <p className="">Staking Reward</p>
                                <h4 className="mb-0 ">
                                  {availableReward && (+ethers.utils.formatEther(availableReward) * 80 / 100).toFixed(2)}
                                </h4>
                              </div>
                              <button
                                className="ms-2 mb-3 btn connect-btn rounded align-self-center"
                                style={{ fontWeight: '700', background: '#00ffc896', color: "white", borderRadius: "7px", border: "none" }}
                                onClick={handleclaimPurchasedTokens}
                              >
                                Claim
                              </button>

                            </div>
                          </div>

                          <div className="w-100 pt-2 d-flex flex-column justify-content-between rounded-xl cards-content-dash" style={{ borderRadius: "10px" }}>
                            <div>
                              <h4>{totalReferralEarning && (+ethers.utils.formatEther(totalReferralEarning)).toFixed(2)}</h4>
                              <p>Referral Reward</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="text-start mt-3" style={{}}>
                        <h5>
                          UNSTAKING
                        </h5>
                      </div>
                      <div className="p-3 mt-3 rounded-xl" style={{ borderRadius: "10px", border: "1px solid #939797" }} >
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-stretch gap-3">
                          <div className="w-100 pt-2 d-flex flex-column justify-content-between rounded-xl cards-content-dash" style={{ borderRadius: "10px" }}>
                            <div>
                              <div className="d-flex justify-content-between align-items-start pt-2" style={{ padding: "0 30px" }}>
                                <p>Available for Unstaking</p>
                                <h4 className="mb-0">
                                  {availablePrincipal && (+ethers.utils.formatEther(availablePrincipal)).toFixed(2)}
                                </h4>
                              </div>
                              <button
                                className="ms-2 mb-3 btn connect-btn rounded align-self-center"
                                style={{ fontWeight: '700', background: '#00ffc896', color: "white", borderRadius: "7px", border: "none" }}
                                onClick={handleclaimPrincipal}
                              >
                                Unstake
                              </button>

                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {stakes.length !== 0 &&
          <div className=" col-12">
            <div className="text-start" style={{}}>
              <h5 className="text-white">
                STAKING HISTORY
              </h5>
            </div>
            <div className="data-cards p-0 card">
              <div className="p-3 text-center card-body table-responsive">
                <table className="mb-0 table table-striped table-hover" >
                  <thead>
                    <tr className="border-0" >
                      <th className="font-roboto text-AmethystSmoke fs-13 fw-400 mt-3 border-0" style={{ background: 'transparent', color: 'white' }}>Stake No</th>
                      <th className="font-roboto text-AmethystSmoke fs-13 fw-400 mt-3 border-0" style={{ background: 'transparent', color: 'white' }}> NEFI<span style={{ color: '#00ffc6' }}>AI</span> Amount</th>
                      <th className="font-roboto text-AmethystSmoke fs-13 fw-400 mt-3 border-0" style={{ background: 'transparent', color: 'white' }}>Start Date</th>
                      <th className="font-roboto text-AmethystSmoke fs-13 fw-400 mt-3 border-0" style={{ background: 'transparent', color: 'white' }}>End Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      stakes?.map(([val, date, bool, val2], index) => (
                        <tr className="border-0">
                          <td className="text-capitalize font-roboto fw-400 fs-17  border-0" style={{ background: 'transparent', color: 'white' }}>{index + 1}</td>
                          <td className="text-capitalize font-roboto fw-400 fs-17  border-0" style={{ background: 'transparent', color: 'white' }}>{ethers.utils.formatEther(val)}</td>
                          <td className="text-capitalize font-roboto fw-400 fs-17  border-0" style={{ background: 'transparent', color: 'white' }}>
                            {new Date(date * 1000).toUTCString()}
                          </td>
                          <td className="text-capitalize font-roboto fw-400 fs-17  border-0" style={{ background: 'transparent', color: 'white' }}>{new Date(+(ethers.utils.formatUnits(date, 1) * 10 + 180 * 86400) * 1000).toUTCString()}</td>
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>}
      </div>

    </UserPageSection>
  );
};

export default Dashboard;


